export default __webpack_public_path__ + "static/hero_cloud_front-3f825b659feff9eacb16492abb4c4837.png";